import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import './styles.scss'

const TitlteWrapperSkeleton = () => (
  <div className="JobFolderAccordionTitleSkeleton">
    <Skeleton width={156} height={16} borderRadius={20} />
    <Skeleton width={121} height={16} borderRadius={20} />
  </div>
)

const CircleSkeleton = () => <Skeleton width={16} height={16} circle />

export function JobFolderAccordionItensSkeleton() {
  return (
    <div className="JobFolderAccordionBodySkeleton">
      <TitlteWrapperSkeleton />
      <TitlteWrapperSkeleton />
      <TitlteWrapperSkeleton />
      <div className="JobFolderAccordionFooterSkeleton">
        <CircleSkeleton />
        <Skeleton width={121} height={16} borderRadius={20} />
      </div>
    </div>
  )
}

function JobFolderAccordionSkeleton({ open }) {
  return (
    <div className="JobFolderAccordionSkeleton">
      <div className="JobFolderAccordionHeaderSkeleton">
        <TitlteWrapperSkeleton />
        <CircleSkeleton />
      </div>

      {open && <JobFolderAccordionItensSkeleton />}
    </div>
  )
}

export default function AddToJobFolderModalSkeleton() {
  return (
    <div className="AddToJobFolderModalSkeleton">
      <JobFolderAccordionSkeleton open />
      <div>
        <JobFolderAccordionSkeleton />
        <JobFolderAccordionSkeleton />
      </div>
    </div>
  )
}
